import { ProfileEnum } from './clinic-list';

export type GetHealthcareByIdPayload = {
  id: string;
  pageSize?: string;
  pageNumber?: string;
};

export type GetHealthcareByIdItem = {
  id: number;
  name: string;
  code: string;
  description: string | null;
  parentId: number;
  parent: number | null;
  isActive: boolean;
  sortOrder: number;
  deposit: number | null;
  categoryImage: string;
  imageUrlLevel2?: string | null;
  imageUrlLevel3?: string | null;
  imageUrlLevel4?: string | null;
  url: string | null;
  children: GetHealthcareByIdItem[];
  products: GetHealthcareByIdProductItem[];
  productId?: number;
  rate?: number | null;
  doctorName?: string | null;
  price?: number;
  discountPercent?: number;
  discountPrice?: number;
  isInstalments?: boolean;
  instalmentCount?: number;
  profileType?: ProfileEnum | null;
  profileId?: number | null;
  createDateTime?: string | null;
  modifiedDateTime?: string | null;
  createBy?: string | null;
  modifiedBy?: string | null;
  profileOwnerId?: number | null;
  serviceId?: number | null;
};

export type GetHealthcareByIdProductItem = {
  id: number;
  name: string;
  code: string;
  description: string | null;
  providerName: string | null;
  slang: string[];
  avatarImage: string | null;
  specialities: string[];
  url: string | null;
  rate: number | null;
  createdAt: string | null;
  price: number | null;
  categoryId: number;
  category: unknown | null;
  isActive: boolean;
  createDateTime: string | null;
};

export type GetHealthcareByIdResponseModel = {
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  queryResult: GetHealthcareByIdItem[];
};

export type GetHealthcareByLevel4Payload = {
  name?: string;
  id: string;
  pageSize?: string;
  pageNumber?: string;
};

export type GetHealthcareByLevel4Item = {
  id: number;
  name: string;
  code: string;
  description: string | null;
  parentId: number;
  parent: number | null;
  isActive: boolean;
  sortOrder: number;
  categoryImage: string;
  imageUrlLevel2: string | null;
  children: [];
  products: [];
  createDateTime: string | null;
  modifiedDateTime: string | null;
  createBy: string | null;
  modifiedBy: string | null;
};

export type GetHealthcareByLevel4ResponseModel = {
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  queryResult: GetHealthcareByLevel4Item[];
};

export enum HealthcareIdEnum {
  services = '1',
  clinics = '2',
}
export type GetHealthcareByLevel2Payload = {
  id: string;
  pageSize?: string;
  pageNumber?: string;
};

export type GetHealthcareByLevel2Item = {
  id: number;
  name: string;
  code: string;
  description: string | null;
  parentId: number;
  parent: number | null;
  isActive: boolean;
  sortOrder: number;
  categoryImage: string;
  imageUrlLevel2: string | null;
  children: [];
  products: [];
  createDateTime: string | null;
  modifiedDateTime: string | null;
  createBy: string | null;
  modifiedBy: string | null;
};

export type GetHealthcareByLevel2ResponseModel = {
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  queryResult: GetHealthcareByLevel2Item[];
};

export type GetServicesCarouselPayload = {
  id: number;
  pageSize?: string;
  pageNumber?: string;
};

export type GetServicesCarouselDetailItem = {
  id: number;
  city: string[] | null;
  clinicId: number | null;
  description: string;
  detailName: string;
  discountPercent: number;
  discountPrice: number;
  deposit: number | null;
  doctorId: number | null;
  imageLink: string | null;
  price: number;
  rank: number | null;
  rate: number | null;
  recId: number;
  reviewCount: number | null;
  servicesCarouselId: number;
  slangName: string[] | null;
  totalPrice: number | null;
  url?: string | null;
  link?: string | null;
};

export type GetServicesCarouselDataModel = {
  backgroundColor: string | null;
  carouselType: number;
  description: string | null;
  descriptionBackgroundColor: string | null;
  details: GetServicesCarouselDetailItem[];
  endTime: string;
  icon: string | null;
  isActive: boolean;
  link: string;
  recId: number;
  sectionPosition: number;
  startTime: string;
  subTitle: string | null;
  subTitleId: string | null;
  title: string;
  type: number;
};

export type GetServicesCarouselResponseModel = GetServicesCarouselDataModel[];

export type GetServicesCarouselDetailPayload = {
  CarouselId: number;
  pageSize?: string;
  pageNumber?: string;
  Search?: string;
};

export type GetServicesCarouselDetailResponseModel = {
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  queryResult: GetServicesCarouselDetailItem[];
};

export type GetClinicCitiesPayload = {
  search?: string;
  pageSize?: string;
  pageNumber?: string;
};

export type GetClinicCitiesItem = {
  id: number;
  CityId: number;
  Name: string;
  ProvinceId: number;
  Sort: number;
};

export type GetClinicCitiesResponseModel = {
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  queryResult: GetClinicCitiesItem[];
};
